export default __webpack_public_path__ + "static/media/icon-download.a1ef54a8.svg";